import React from "react";
import AlertBox from "../../../common/UI/AlertBox/AlertBox";
import { inject, observer } from "mobx-react";
import "../../../../assets/css/components/Modal/Modal.css";
import failIcon from "../../../../assets/images/fail.png";
import Icon from "react-icons-kit";
import { close } from "react-icons-kit/ionicons/close";

const CancelInvitation = inject("sharedStore")(
  observer((store) => {
    const {sharedStore,
    modalVisibility,
    modalLabel,
    closeModalHandler,
    modalClass,
    userId,
    } = store;

    const handleSubmit = async (e, userId) => {
     await sharedStore.cancelInvitation(userId)
      closeModalHandler();
    };
  

    return (
      <AlertBox
        alertVisibility={modalVisibility}
        closeAlertBoxHandler={closeModalHandler}
        alertClass={modalClass}
        backdrop={false}
        alertLabel={modalLabel}
      >
        <div className="modal-wrapper">
          <div className="text-right">
            <span onClick={closeModalHandler}>
              <Icon size={20} icon={close} className="cursor-pointer" />
            </span>
          </div>
          <div className="text-center mar">
            <img className="imge-fail" src={failIcon} alt="error" />
          </div>
          <p className="content-modal text-center">
            Message
            <br />
            <a className="btn btn-link">
              Are you sure you want to completely remove this user?
            </a>
          </p>
          <div className="text-center">
            <button onClick={closeModalHandler} className="btn btn-org">
              Cancel
            </button>
            <button
              onClick={(e) => handleSubmit(e, userId)}
              className="btn btn-org"
            >
              Remove User Data
            </button>
          </div>
        </div>
      </AlertBox>
    );

  }))

export default CancelInvitation;



// WEBPACK FOOTER //
// ./src/components/Profile/MemberComponent/CancelInvitation/CancelInvitation.jsx